import React, { useContext } from 'react';
import IconsMapper from 'common/components/IconsMapper/IconsMapper';
import MapContext from 'common/contexts/map-context';
import MapService from 'common/services/Map';
import TrackingService from 'common/services/Tracking/Tracking';

const Itinary = ({ merchant }) => {
  const [map] = useContext(MapContext);
  const getItinaryLink = async (e) => {
    e.preventDefault();
    if (map.scriptInited) {
      const { pagination } = await MapService.goToGeolocation(false);
      const infos = await MapService.getItinaryURL(merchant, {
        lat: pagination.from_lat,
        lng: pagination.from_lng,
      });

      // L'événement `direction` avait disparu en passant de `VOG` à `2025_VOG` :
      // `templates/VOG/.../PlaceInfos.js:26` le pistait ici, tout comme
      // `common/components/StoreCard.js:43` et `GStaticMap.js:37`. Sans lui, le
      // clic « Calculer l'itinéraire » — l'autre conversion d'une fiche, avec
      // l'appel — n'existait pas dans les stats.
      TrackingService.trackClickToDirection(merchant.id, 'real');

      if (!window.open(infos.url, infos.target)) {
        window.location = infos.url;
      }
    }
  };

  return (
    <a
      href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(merchant.address?.street + ' ' + merchant.address?.zip + ' ' + merchant.address?.city)}`}
      className="sl-flex sl-ai-center sl-gap-s sl-cursor-pointer"
      onClick={(e) => getItinaryLink(e)}
      rel="nofollow noopener noreferrer"
      aria-label="Calculer l'itinéraire vers le salon"
    >
      <IconsMapper icon={'faLocationDot'} aria-hidden="true" />
      <strong
        style={{
          fontSize: 'clamp(14px, 2vw, 16px)',
        }}
      >
        Calculer l'itinéraire
      </strong>
    </a>
  );
};

export default Itinary;
